
/* eslint-disable no-template-curly-in-string */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, memo, useMemo } from 'react';
import { isURL } from 'validator';
import { Icon, Input, Button } from '../../../../../../../../ui-kit';
import { SubOptionBlock, InputElementBlock } from '../../Blocks/components/common/StyledEditables';

const MAILTO_REGEX = /^((mailto:+)([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-.]+)@{[a-zA-Z0-9_\-.]+0\.([a-zA-Z]{2,5}){1,25})+)*$/;






const isURLOptions = {
  protocols: ['http', 'https'],
  require_protocol: true
};

const InputBlock = (
{ inputData, handleInputChanges }) =>
{
  const [inputValue, setInputValue] = useState(inputData.value);

  useEffect(() => {
    if (inputData) {
      setInputValue(inputData.value);
    }
  }, [inputData]);

  const updateInputValue = (e) => {
    setInputValue(e.target.value);
  };

  const clearInput = (e) => {
    e.stopPropagation();
    setInputValue('');
  };

  const updateInput = (e) => {
    e.stopPropagation();
    handleInputChanges(inputValue);
  };

  const isValid = useMemo(() => {
    if (inputData.isRequired && !inputValue) {
      return false;
    }

    if (inputValue && (inputData.isLink || inputData.isEmail)) {
      const isLink = isURL(inputValue, isURLOptions);

      const checkLinkStatus = inputData.isLink && (isLink || MAILTO_REGEX.test(inputValue));
      const checkMailtoStatus = inputData.isEmail && (
      inputValue === 'mailto:${email}' || inputValue === '${calendarLink}');

      if (!checkLinkStatus && !checkMailtoStatus) {
        return false;
      }
    }

    return true;
  }, [inputValue, inputData]);

  return (
    <SubOptionBlock style={inputData.style} onClick={(e) => e.stopPropagation()}>
      <InputElementBlock>
        <div className="input-element">
          <Input
            value={inputValue}
            defaultValue={inputValue}
            placeholder={inputData.placeholder}
            onChange={updateInputValue}
            disabled={inputData.isDisabled} />

          {!inputData.isDisabled &&
          <Icon name="close" color="black" size={14} onClick={clearInput} />}

        </div>
        <Button onClick={updateInput} disabled={!isValid} className={!isValid ? 'button__disabled' : ''}>
          <Icon name="success" color="white" size={14} />
        </Button>
      </InputElementBlock>
    </SubOptionBlock>);

};
export default memo(InputBlock);